import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
// @mui material components
// import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKAlert from "components/MKAlert";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Pricing page sections
//import Header from "./sections/Header";
import ServicesSection from "./sections/Services";
import CTASection from "./sections/CTASection";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Material Kit 2 PRO React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

//--- Images ---
import bg1 from "assets/images/examples/content-0.jpg";
import bg2 from "assets/images/examples/content-1.jpg";
import bg3 from "assets/images/examples/content-2.jpg";
import bg4 from "assets/images/examples/content-3.jpg";
import bg5 from "assets/images/examples/content-4.jpg";
import bg6 from "assets/images/examples/content-5.jpg";
import contactImage from "assets/images/examples/content-6.jpg";
import heroBg from "assets/images/bg2.jpg";
//import heroBg from "assets/images/bg2.jpg";
import { keyframes } from "@mui/system";

//motion
import { motion } from "framer-motion";

function Home() {
  // server from env
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  //vars declaration
  const [alertMsg, setAlertMsg] = useState("");
  const [names, setNames] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  //--- function to handle submit ---
  const handleContact = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSent(false);
    const data = JSON.stringify({
      names: names,
      email: email,
      phone: phone,
      message: message,
    });

    axios
      .post(SERVER_URL + "/contact/post/", data, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: false,
      })
      .then((res) => {
        if (res.status === 200 && res.data === "Contacted") {
          setAlertMsg("Email Sent!, We'll Get Back to You Very Soon");
          setIsSent(true);
        } else {
          alert("BYANZE, Subscription Yawe");
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
`;

  return (
    <>
      <DefaultNavbar routes={routes} transparent light />
      <MKBox
        component="section"
        minHeight="75vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          position: "relative",
          textAlign: "center",
          py: { xs: 4, md: 6 },
          px: { xs: 2, md: 0 },
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          "&:before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 1,
            transition: "all 0.5s ease-in-out",
          },
        }}
      >
        <Grid container justifyContent="center" sx={{ position: "relative", zIndex: 2 }}>
          <Grid item xs={12} md={10} lg={8}>
            {/*  Title */}
            <MKTypography
              variant="h4"
              color="white"
              fontWeight="bold"
              mb={2}
              sx={{
                textTransform: "uppercase",
                letterSpacing: "1.5px",
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                animation: `${fadeIn} 1s ease forwards`,
              }}
            >
              The Best Helper
            </MKTypography>

            {/* Assistance Button */}
            <MKBox
              display="flex"
              justifyContent="center"
              mb={4}
              sx={{ animation: `${fadeIn} 1.2s ease forwards` }}
            >
              <Link to="/employer" style={{ textDecoration: "none" }}>
                <MKButton
                  variant="contained"
                  size="large"
                  sx={{
                    backgroundColor: "#003060",
                    color: "#fff",
                    borderRadius: "14px",
                    px: 6,
                    py: 1.8,
                    fontSize: "1.1rem",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    boxShadow: "0 4px 15px rgba(0, 48, 96, 0.3)",
                    transition: "all 0.35s ease",
                    "&:hover": {
                      backgroundColor: "#002244",
                      transform: "translateY(-3px)",
                      boxShadow: "0 6px 20px rgba(0, 48, 96, 0.45)",
                    },
                    "&:active": {
                      transform: "translateY(0)",
                      boxShadow: "0 3px 10px rgba(0, 48, 96, 0.3)",
                    },
                  }}
                >
                  REQUEST FOR ASSISTANCE
                </MKButton>
              </Link>
            </MKBox>

            {/* Short Description */}
            <MKTypography
              variant="body1"
              color="white"
              fontSize={{ xs: "0.9rem", sm: "1rem", md: "1.1rem" }}
              mb={3}
              sx={{
                maxWidth: "700px",
                mx: "auto",
                opacity: 0.95,
                animation: `${fadeIn} 1.4s ease forwards`,
              }}
            >
              Your trusted partner for a carefree and enjoyable stay in East Africa. Dedicated to
              assisting foreigners and diaspora in finding the essentials they need upon arrival.
            </MKTypography>

            {/* Countries in horizontal direction */}
            <MKBox
              display="flex"
              justifyContent="center"
              gap={{ xs: 2, sm: 4 }}
              flexWrap="wrap"
              mt={2}
              sx={{ animation: `${fadeIn} 1.6s ease forwards` }}
            >
              {["Rwanda", "Kenya", "Uganda", "Tanzania"].map((country, idx) => (
                <MKTypography
                  key={idx}
                  variant="button"
                  color="white"
                  fontWeight="medium"
                  sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
                >
                  {country}
                </MKTypography>
              ))}
            </MKBox>
          </Grid>
        </Grid>
      </MKBox>
      <MKBox component="section" py={{ xs: 4, md: 6 }}>
        <Container>
          {/* Optional Section Title */}
          <Grid
            container
            item
            xs={12}
            flexDirection="column"
            alignItems="center"
            mx="auto"
            textAlign="center"
            mb={6}
          >
            {/* You can add a heading or description here */}
          </Grid>

          <Grid container spacing={3}>
            {[bg1, bg2, bg3, bg4, bg5, bg6].map((bg, idx) => (
              <Grid
                item
                key={idx}
                xs={12} // full width on mobile
                sm={6} // 2 per row on small screens
                md={4} // 3 per row on medium screens
                lg={4} // 3 per row on large screens as well
              >
                <MKBox
                  width="100%"
                  sx={{
                    aspectRatio: "1 / 1", // keep square ratio
                    borderRadius: "1.5rem",
                    shadow: "md",
                    backgroundImage: `url(${bg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    transition: "transform 0.4s ease, box-shadow 0.4s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: "0 12px 30px rgba(0,0,0,0.3)",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </MKBox>
      <ServicesSection />
      <MKBox component="section" py={8}>
        <Container>
          {/* Section Header */}
          <Grid
            container
            item
            justifyContent="center"
            xs={12}
            lg={8}
            sx={{ mx: "auto", textAlign: "center", mb: 6 }}
          >
            <MKTypography
              variant="h3"
              color="#003060"
              fontWeight="bold"
              sx={{
                letterSpacing: "-0.5px",
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              }}
            >
              Why Choose Us
            </MKTypography>
            <MKTypography
              variant="body1"
              color="#003060"
              sx={{ mt: 2, opacity: 0.85, fontSize: { xs: "1rem", md: "1.1rem" } }}
            >
              We simplify your journey by eliminating travel headaches and ensuring every moment
              feels seamless. Designed with a modern touch, our services adapt to your lifestyle, so
              you can focus on what matters most.
            </MKTypography>
          </Grid>

          {/* Feature Cards */}
          <Grid container spacing={4}>
            <Grid item xs={12} md={6} lg={4}>
              <DefaultInfoCard
                icon="groups"
                title="Expert Team"
                description="A highly skilled team dedicated to guiding and supporting you with a premium, personalized experience."
                direction="center"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <DefaultInfoCard
                icon="support_agent"
                title="Always Available"
                description="Get 24/7 real-time support. No matter where you are, help is just a call away."
                direction="center"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} sx={{ mx: "auto" }}>
              <DefaultInfoCard
                icon="update"
                title="Flexible Services"
                description="From tailored travel plans to on-demand adjustments, our solutions evolve with your needs."
                direction="center"
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>

      <CTASection />
      <MKBox
        component="section"
        display="grid"
        position="relative"
        minHeight="90vh"
        borderRadius="xl"
        mr={{ xs: 0, lg: 8 }}
        mb={{ xs: 0, lg: -2 }}
        mt={{ xs: 0, lg: 5 }}
        sx={{ overflow: { xs: "hidden", lg: "visible" }, placeItems: "center" }}
      >
        {/* Background Image */}
        <MKBox
          component="img"
          alt="lake house"
          src={contactImage}
          width={{ xs: "100%", lg: "50%" }}
          height={{ xs: "100%", lg: "100%" }}
          position="absolute"
          right={0}
          bottom={{ xs: "-25%", lg: "unset" }}
          top={{ xs: 0, lg: "unset" }}
          sx={{
            objectFit: "cover",
            borderTopLeftRadius: ({ borders: { borderRadius } }) => ({
              xs: 0,
              lg: borderRadius.lg,
            }),
          }}
        />

        <Container>
          <Grid container spacing={{ xs: 0, lg: 3 }} sx={{ mt: { xs: 0, lg: 12 } }}>
            <Grid item xs={12} lg={7} justifyContent="center" flexDirection="column">
              {/* White Card */}
              <MKBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                shadow="xl"
                borderRadius="xl"
                sx={{
                  backgroundColor: ({ palette: { white } }) => white.main, // solid white
                  px: { xs: 4, sm: 8 },
                  py: { xs: 4, sm: 10 },
                  mb: { xs: 0, lg: 8 },
                  mt: { xs: 0, lg: -6 },
                  boxShadow: "0 12px 40px rgba(0,0,0,0.15)", // modern Apple-like shadow
                }}
              >
                {/* Title */}
                <MKTypography
                  variant="h3"
                  textAlign="center"
                  mb={2}
                  fontWeight="bold"
                  sx={{ letterSpacing: "0.5px" }}
                >
                  Contact Us
                </MKTypography>

                {/* Form */}
                <MKBox component="form" role="form" onSubmit={handleContact} autoComplete="off">
                  {alertMsg.length > 0 && (
                    <motion.div
                      initial={{ x: -200, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ duration: 1.2, ease: "easeOut" }}
                    >
                      <MKAlert color="info">{alertMsg}</MKAlert>
                    </motion.div>
                  )}

                  <MKBox py={3} px={{ xs: 2, md: 10, lg: 6, xl: 10 }}>
                    <Grid container spacing={3} sx={{ mb: 3 }}>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          placeholder="Your Name"
                          label="Name"
                          onChange={(e) => setNames(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          placeholder="Phone Number"
                          label="Telephone"
                          onChange={(e) => setPhone(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MKInput
                          variant="standard"
                          type="email"
                          placeholder="Email Address"
                          label="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MKInput
                          variant="standard"
                          label="Your Message"
                          onChange={(e) => setMessage(e.target.value)}
                          rows={5}
                          multiline
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid item xs={12}>
                        <MKButton
                          variant="gradient"
                          color={isSent ? "info" : "primary"}
                          type="submit"
                          fullWidth
                          disabled={isLoading || isSent}
                          sx={{ py: 1.8, fontWeight: "bold", fontSize: "1rem" }}
                        >
                          {isLoading ? "Sending Email..." : isSent ? "Email Sent" : "Send Message"}
                        </MKButton>
                      </Grid>
                    </Grid>
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
          </Grid>
        </Container>
      </MKBox>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Home;
